import SkyscraperBackground from '@/components/SkyscraperBackground';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useLocation } from '@/hooks/useLocation';
import {
  Box,
  Text,
  Button,
  Grid,
  LoadingWarren,
  LoadingSpinner,
} from '@simplywallst/ui-core';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { updateChurn } from '@simplywallst/services';
import { withAuth } from '@/utilities/queries';
import { useEffect } from 'react';

export function SubscriptionExtension() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { mutate, status } = useMutation({
    mutationFn(action: string) {
      return withAuth(updateChurn, action);
    },
  });

  useEffect(() => {
    if (typeof location.query?.action === 'string') {
      mutate(location.query?.action);
    }
  }, [location.query?.action, mutate]);

  return (
    <SkyscraperBackground>
      {status === 'success' && (
        <>
          <Box paddingBottom="x1" paddingTop="x1">
            <Text color="almostBlack" typography="small">
              {location.query?.confirmation || ''}
            </Text>
          </Box>
          <Box paddingBottom="x1" paddingTop="x1">
            <Grid placeItems="center">
              <Button
                type="button"
                styleType="louderLarge"
                onClick={() => {
                  dispatch(redirect({ type: ROUTE_DASHBOARD }));
                }}
              >
                Go to Platform
              </Button>
            </Grid>
          </Box>
        </>
      )}
      {status === 'pending' && (
        <>
          <Box paddingBottom="x1" paddingTop="x1">
            <LoadingWarren />
          </Box>
          <Box paddingBottom="x1" paddingTop="x1">
            <LoadingSpinner left="50%" />
          </Box>
        </>
      )}
      {status === 'error' && (
        <Box paddingBottom="x1" paddingTop="x1">
          <Text color="almostBlack" typography="small">
            An unknown error has occurred.
          </Text>
        </Box>
      )}
    </SkyscraperBackground>
  );
}
